export default __webpack_public_path__ + "static/media/swipe_360.fb41730f.gif";